module.exports = __webpack_public_path__ + "static/media/Sap.db871642.png";